import { Toast } from 'antd-mobile'
import axios, { AxiosResponse } from 'axios'

const baseURL = `${process.env.NEXT_PUBLIC_HOST}${process.env.NEXT_PUBLIC_BASE_PATH}`
const timeout = 60000

const instance = axios.create({
  baseURL,
  timeout,
})

export interface Res {
  code: number
  message: string
  data: any
}

instance.interceptors.response.use(
  (response) => {
    const { code, data, message } = response.data
    if (code === 0 || code === 200) return data
    if (code === -1) {
      Toast.show(message)
      return Promise.reject(response.data as AxiosResponse<Res>)
    }
    // 其他业务侧异常状态码
    return response.data
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default instance
